import { AssetAllocation } from '../components/report/AssetAllocation';
import { AssetClassPerformance } from '../components/report/AssetClassPerformance';
import { CashTransactions } from '../components/report/CashTransactions';
import { ContributionsAndWithdrawals } from '../components/report/ContributionsAndWithdrawals';
import { CurrencyExposure } from '../components/report/CurrencyExposure';
import { Expenses } from '../components/report/Expenses';
import { HoldingsVsTargetVariance } from '../components/report/HoldingsVsTargetVariance';
import { IncomeReport } from '../components/report/IncomeReport';
import { InvestmentIncomeTax } from '../components/report/InvestmentIncomeTax';
import { PorfolioPerformance } from '../components/report/PortfolioPerformance';
import { PortfolioSnapshot } from '../components/report/PortfolioSnapshot';
import { PortfolioValuation } from '../components/report/PortfolioValuation';
import { ProjectedIncomeCashflow } from '../components/report/ProjectedIncomeCashflow';
import { RealisedCapitalGainsAndLosses } from '../components/report/RealisedCapitalGainsAndLosses';
import { SecurityContribution } from '../components/report/SecurityContribution';
import { SecurityPerformance } from '../components/report/SecurityPerformance';
import { TaxInvoice } from '../components/report/TaxInvoice';
import { TaxSummary } from '../components/report/TaxSummary';
import { TransactionHistory } from '../components/report/TransactionHistory';
import { UnrealisedCapitalGainsAndLosses } from '../components/report/UnrealisedCapitalGainsAndLosses';
import { UnrealisedNonCGTGainsAndLosses } from '../components/report/UnrealisedNonCGTGainsAndLosses';
import { UXChangeTaxStatementReport } from '../components/report/UXChangeTaxStatementReport';
import { ReportComponentConfig, ReportFormat } from './types';

export const ReportingComponentListOptions: ReportComponentConfig[] = [
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    component: AssetAllocation,
  },
  {
    component: AssetClassPerformance,
  },
  {
    component: CashTransactions,
  },
  {
    excelFeatureFlagged: true,
    component: ContributionsAndWithdrawals,
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    component: CurrencyExposure,
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    component: Expenses,
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    component: HoldingsVsTargetVariance,
  },
  {
    excelFeatureFlagged: true,
    component: IncomeReport,
  },
  {
    excelFeatureFlagged: true,
    component: InvestmentIncomeTax,
  },
  {
    component: PorfolioPerformance,
  },
  {
    component: PortfolioSnapshot,
  },
  {
    component: PortfolioValuation,
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    featureFlagged: true,
    component: ProjectedIncomeCashflow,
  },
  {
    component: RealisedCapitalGainsAndLosses,
    excelFeatureFlagged: true,
  },
  {
    component: SecurityContribution,
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
  },
  {
    component: SecurityPerformance,
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    component: TaxInvoice,
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    nonSuperOnly: true,
    component: TaxSummary,
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    component: TransactionHistory,
  },
  {
    excelFeatureFlagged: true,
    component: UnrealisedCapitalGainsAndLosses,
  },
  {
    excelFeatureFlagged: true,
    component: UnrealisedNonCGTGainsAndLosses,
  },
  {
    supportedFormats: [ReportFormat.PDF, ReportFormat.JSON],
    isAdminOnly: true,
    component: UXChangeTaxStatementReport,
  },
];
